module.exports = __webpack_public_path__ + "static/media/churchxLogo.e50fc9ca.svg";